import { render, staticRenderFns } from "./surquillo_map.vue?vue&type=template&id=b2371c5c"
import script from "./surquillo_map.vue?vue&type=script&lang=js"
export * from "./surquillo_map.vue?vue&type=script&lang=js"
import style0 from "./surquillo_map.vue?vue&type=style&index=0&id=b2371c5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports